import "./shop.css";

import React from "react";
import { Link, useParams } from "react-router-dom";

import { ROUTES, categoryPath } from "../../data/content";
import { artworkImage, getArtist, getArtwork, getArtworksBy } from "../../data/gallery";
import { useEnquiry } from "../general/Enquiry";
import ArtworkCard from "../general/ArtworkCard";
import NotFound from "../general/NotFound";
import PageMeta from "../general/PageMeta";
import Slider from "../general/Slider";

//One artwork (the Wix store's product page, same URL). No cart - "Enquire" fills in the Contact Us form instead
const Artwork = () => {
  const { slug } = useParams();
  const { startEnquiry } = useEnquiry();
  const [imageIndex, setImageIndex] = React.useState(0);
  const artwork = getArtwork(slug);

  React.useEffect(() => {
    setImageIndex(0);
  }, [slug]);

  if (!artwork) {
    return <NotFound />;
  }

  const artist = getArtist(artwork.artist);
  const artistName = artist.slug === "ardmore" ? "Ardmore Ceramics" : artist.name;
  const artistPage = artist.path || ROUTES.ARDMORE;
  const moreWorks = getArtworksBy(artist.slug).filter((a) => a.slug !== slug).slice(0, 12);

  return (
    <div className={"page artwork-page"}>
      <PageMeta
        title={artwork.name}
        description={`${artwork.name} by ${artistName}. ${artwork.details.join(" ")} ${artwork.price} - enquire at The Charles Greig Gallery, Hyde Park Corner.`}
      />

      <nav
        className={"breadcrumbs container"}
        aria-label={"Breadcrumb"}
      >
        <Link to={ROUTES.HOME}>Home</Link>
        <span aria-hidden={"true"}>›</span>
        <Link to={categoryPath(artist.category)}>{artist.name}</Link>
        <span aria-hidden={"true"}>›</span>
        <span aria-current={"page"}>{artwork.name}</span>
      </nav>

      <div className={"artwork-layout container"}>
        <div className={"artwork-gallery"}>
          <div className={"artwork-photo"}>
            <img
              key={artwork.images[imageIndex]}
              src={artworkImage(artwork.images[imageIndex])}
              alt={artwork.name}
              width={1200}
              height={1200}
            />
          </div>
          {artwork.images.length > 1 ? (
            <ul className={"artwork-thumbs"}>
              {artwork.images.map((image, i) => (
                <li key={image}>
                  <button
                    type={"button"}
                    className={i === imageIndex ? "is-active" : ""}
                    onClick={() => setImageIndex(i)}
                    aria-label={`Show photo ${i + 1}`}
                    aria-current={i === imageIndex ? "true" : undefined}
                  >
                    <img
                      src={artworkImage(image, true)}
                      alt={""}
                      width={80}
                      height={80}
                    />
                  </button>
                </li>
              ))}
            </ul>
          ) : null}
        </div>

        <div className={"artwork-info"}>
          <h1 className={"artwork-name"}>{artwork.name}</h1>
          <p className={"artwork-artist"}>
            by <Link to={artistPage}>{artistName}</Link>
          </p>
          <p className={"artwork-price"}>
            <span className={"visually-hidden"}>Price: </span>
            {artwork.price}
          </p>
          {artwork.details.length ? (
            <div className={"artwork-details"}>
              {artwork.details.map((line) => (
                <p key={line}>{line}</p>
              ))}
            </div>
          ) : null}
          <button
            type={"button"}
            className={"btn artwork-enquire"}
            onClick={() => startEnquiry(artwork, artistName)}
          >
            ENQUIRE ABOUT THIS ARTWORK
          </button>
          <p className={"artwork-note"}>
            To view or purchase this piece, visit the gallery at Hyde Park Corner or send us an enquiry.
          </p>
        </div>
      </div>

      {moreWorks.length ? (
        <section
          className={"artwork-more container"}
          aria-labelledby={"more-title"}
        >
          <h2
            id={"more-title"}
            className={"section-title"}
          >
            More by {artistName}
          </h2>
          <Slider label={`More by ${artistName}`}>
            {moreWorks.map((a) => (
              <ArtworkCard
                key={a.slug}
                artwork={a}
              />
            ))}
          </Slider>
        </section>
      ) : null}
    </div>
  );
};

export default Artwork;
